<template>
  <v-dialog v-model="internalDialog" max-width="920" persistent scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Chi tiết công việc
        <v-spacer />
        <v-btn dark icon>
          <v-icon @click="close">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-tabs v-model="activeTab" background-color="primary" dark>
        <v-tab>Thông tin cơ bản</v-tab>
        <v-tab>Lịch sử thay đổi</v-tab>
      </v-tabs>

      <v-card-text style="padding: 0; max-height: 65vh; overflow-y: auto">
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card-text>
              <v-form ref="form" v-bind="this.$attrs" class="px-4 py-4">
                <v-row>
                  <v-col cols="3">
                    <span class="grey--text text--darken-1">Tên công việc</span>
                  </v-col>
                  <v-col cols="9">
                    <p class="mb-0">{{ form.title }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <span class="grey--text text--darken-1">Người giao việc</span>
                  </v-col>
                  <v-col cols="9">
                    <v-chip :key="form.creatorData._id" class="grey white--text">
                      <v-avatar left color="white">
                        <img :src="avatar(form.creatorData.avatar)" alt="avatar" />
                      </v-avatar>
                      {{ form.creatorData.name }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <span class="grey--text text--darken-1">Người nhận việc</span>
                  </v-col>
                  <v-col cols="9" class="d-flex flex-wrap" style="gap: 12px">
                    <v-chip v-for="user in form.receivers.slice(0, 7)" :key="user._id" class="grey white--text">
                      <v-avatar left color="white">
                        <img :src="avatar(user)" alt="avatar" />
                      </v-avatar>
                      {{ user.name }}
                    </v-chip>
                    <v-tooltip top v-if="form.receivers.length > 7">
                      <template #activator="{ on, attrs }">
                        <div class="avatar-wrapper mr-2" v-on="on" v-bind="attrs">
                          <v-avatar size="32" color="grey">
                            <span class="white--text font-weight-bold text-caption">
                              +{{ form.receivers.length - 7 }}
                            </span>
                          </v-avatar>
                        </div>
                      </template>
                      <span style="white-space: pre-line">{{
                        form.receivers
                          .slice(7)
                          .map(u => u.name || u.username)
                          .join('\n')
                      }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <span class="grey--text text--darken-1">Mức ưu tiên</span>
                  </v-col>
                  <v-col cols="9">
                    <p class="mb-0" :style="{ color: priority.color, fontSize: '16px' }">
                      {{ priority.text }}
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <span class="grey--text text--darken-1">Trạng thái công việc</span>
                  </v-col>
                  <v-col cols="9">
                    <p class="mb-0" :style="{ color: statusColor(form.status), fontSize: '16px' }">
                      {{ statusText(form.status) }}
                    </p>
                  </v-col>
                </v-row>
                <v-row v-if="form.status == 'completed'">
                  <v-col cols="3">
                    <span class="grey--text text--darken-1">Ngày hoàn thành</span>
                  </v-col>
                  <v-col cols="9">
                    <p class="mb-0">{{ form.completed_at | ddmmyyyy }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <span class="grey--text text--darken-1">Hạn hoàn thành</span>
                  </v-col>
                  <v-col cols="9">
                    <p class="mb-0">{{ form.due_date | ddmmyyyy }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <span class="grey--text text--darken-1">Mô tả công việc</span>
                  </v-col>
                  <v-col cols="9">
                    <div class="description-content" v-html="form.description"></div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <v-list dense>
                <v-list-item v-for="(log, idx) in history" :key="idx" class="align-start">
                  <v-list-item-icon style="min-width: 20px; margin-right: 8px">
                    <v-icon color="primary" class="mb-1">mdi-circle-small</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <div class="text-caption grey--text">
                      {{ log.performed_by.name }} - {{ log.createdAt | ddmmyyyyhhmm }}
                    </div>
                    <div class="mt-1" v-if="log.note">{{ log.note }}</div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions v-if="this.isCreator()" class="d-flex justify-space-between pa-6">
        <template>
          <v-spacer />
          <v-btn outlined color="#0D47A1" @click="$emit('edit', task)">Sửa công việc</v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import get from 'lodash-es/get'
import { VueEditor } from 'vue2-editor'
import { mapGetters } from 'vuex'

export default {
  components: {
    VueEditor,
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    dialog: Boolean,
  },
  data() {
    return {
      activeTab: 0,
      newStatus: '',
      internalDialog: this.dialog,
      form: {
        title: '',
        description: '',
        status: '',
        priority: null,
        due_date: '',
        completed_at: '',
        note: '',
        receivers: [],
        creatorData: {},
        evaluation: '',
      },
      history: [],
      statusOptions: [
        { text: 'Chưa bắt đầu', value: 'not_started', color: 'grey' },
        { text: 'Đang thực hiện', value: 'in_progress', color: 'orange' },
        { text: 'Hoàn thành', value: 'completed', color: 'green' },
        { text: 'Chờ đánh giá', value: 'waiting', color: 'red' },
      ],
      evaluationOptions: [
        { value: 'excellent', label: 'Xuất sắc' },
        { value: 'average', label: 'Tốt' },
        { value: 'failed', label: 'Trung bình' },
        { value: 'warned', label: 'Yếu' },
      ],
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    priority() {
      const priorities = [
        { value: 0, text: 'Khẩn cấp', color: 'red' },
        { value: 1, text: 'Cao', color: 'orange' },
        { value: 2, text: 'Bình thường', color: 'blue' },
        { value: 3, text: 'Thấp', color: 'grey darken-1' },
        { value: 4, text: 'Rất thấp', color: 'grey' },
      ]
      return priorities.find(p => p.value === this.form.priority) || { text: 'Không xác định', color: 'grey' }
    },
  },
  watch: {
    dialog(val) {
      this.internalDialog = val
      if (val) this.initData()
    },
    internalDialog(val) {
      if (!val) this.$emit('close')
    },
  },
  methods: {
    avatar(item) {
      return get(item, 'avatar.url', require('@/assets/default-avatar.svg'))
    },
    statusText(status) {
      const map = {
        not_started: 'Chưa bắt đầu',
        in_progress: 'Đang thực hiện',
        completed: 'Hoàn thành',
        waiting: 'Chờ đánh giá',
      }
      return map[status] || '-'
    },
    statusColor(status) {
      const map = {
        not_started: 'grey',
        in_progress: 'orange',
        completed: 'green',
        waiting: 'red',
      }
      return map[status] || 'grey'
    },
    initData() {
      if (!this.task) return
      this.form = {
        title: this.task.title,
        status: this.task.status,
        priority: this.task.priority,
        description: this.task.description || '',
        due_date: this.task.due_date,
        completed_at: this.task.completed_at,
        note: this.task.note || '',
        creatorData: this.task.creatorData || {},
        receivers: this.task.receiversData || [],
      }
      this.fetchHistory()
    },
    isCreator() {
      if (!this.task || !this.user) return false
      return this.task.creatorData.user_id === this.user.id
    },
    actionText(action) {
      const map = {
        create: 'Tạo công việc',
        update: 'Cập nhật công việc',
        change_status: 'Thay đổi trạng thái',
        assign: 'Giao lại công việc',
        delete: 'Xoá công việc',
      }
      return map[action] || action
    },
    async fetchHistory() {
      const res = await this.$store.dispatch('tasknew/fetchTaskHistory', this.task._id)
      if (res) this.history = res
    },
    close() {
      this.internalDialog = false
    },
  },
}
</script>

<style scoped>
.v-subheader {
  width: 30%;
}
p {
  color: black;
}
.p > .v-input__control > .v-input__slot:before {
  border-style: none;
}
</style>
